<template>
	<div>
		<a-page-header title="Channels">
			<template slot="extra">
				<a-button key="1" type="primary" @click="showAddModal()"
					>Add New Channel</a-button
				>
			</template>
		</a-page-header>
		<data-table
			ref="channelsDataTable"
			:columns="columns"
			:data-source="channelState.channels"
			:loading="loading"
			@refreshData="fetchChannels"
			:totalCount="channelState.channelsCount"
			rowKey="id"
		>
			<span slot="action" slot-scope="record">
				<a-tooltip title="Invite">
					<a @click="showCustomLinkModal(record.id)">
						<a-icon type="mail" />
					</a>
				</a-tooltip>

				<a-divider type="vertical" />
				<a-tooltip title="Edit">
					<a class="edit-icon" @click="showEditModal(record.id)">
						<a-icon type="edit" />
					</a>
				</a-tooltip>

				<a-divider type="vertical" />
				<a-tooltip title="Delete">
					<a class="trash-icon" @click="confirmDelete(record.id)">
						<a-icon type="delete" /> </a
				></a-tooltip>
			</span>
		</data-table>
		<ChannelModal
			v-model="isChannelModalVisible"
			:businesses="businessState.businesses"
			:channel="channel"
			:title="modalTitle"
			:mode="mode"
		></ChannelModal>
		<CustomPlanInvitation
			v-model="isCustomLinkModalVisible"
			:plans="plansState.plans"
			:channelId="customPlanChannelId"
		/>
	</div>
</template>
<script>
import {
	channelState,
	channelMutations,
	businessState,
	businessMutations,
	plansState,
	plansMutations,
} from "../../Store/store.js";
import ChannelModal from "./ChannelModal.vue";
import CustomPlanInvitation from "./CustomPlanInvitation.vue";

const columns = [
	{
		title: "Name",
		dataIndex: "name",
		key: "name",
		sorter: true,
		ellipsis: true,
	},
	{
		title: "Actions",
		key: "action",
		scopedSlots: { customRender: "action" },
		ellipsis: true,
		width: 100,
	},
];

export default {
	async mounted() {
		await this.fetchChannels();
		await this.fetchBusinesses();
	},
	data() {
		return {
			channelState,
			channelMutations,
			businessState,
			businessMutations,
			plansState,
			plansMutations,
			columns: columns,
			isSaving: false,
			loading: false,
			isChannelModalVisible: false,
			channel: {},
			mode: "Add",
			modalTitle: "",
			isCustomLinkModalVisible: false,
			customPlanChannelId: null,
		};
	},
	methods: {
		async fetchChannels(params) {
			await this.channelMutations.setChannels(params);
		},
		async fetchBusinesses() {
			await businessMutations.setBusinesses();
		},
		async fetchPlans() {
			await plansMutations.getPlans();
		},
		showAddModal() {
			this.mode = "Add";
			this.channel = {};
			this.modalTitle = `${this.mode} channel`;
			this.isChannelModalVisible = true;
		},
		showEditModal(recordId) {
			this.mode = "Update";
			this.channel = {
				...this.channelState.channels.find((i) => i.id == recordId),
			};
			this.modalTitle = `${this.mode} channel`;
			this.isChannelModalVisible = true;
		},
		copyLink(channelId) {
			let base = window.location.host;
			try {
				let url = `${base}/signup.html?${this.$skipPaymentKey}=${this.$skipPaymentKey}&${this.$skipPaymentChannelKey}=${channelId}`;
				navigator.clipboard.writeText(url);
				this.$message.success("Signup page link copied to clipboard!");
			} catch (e) {
				this.$message.error("Error while copying link for this channel!");
			}
		},
		confirmDelete(channelId) {
			let self = this;
			this.$confirm({
				title: "Delete Channel",
				content: "Are you sure you want to delete this channel?",
				okText: "Delete",
				okType: "danger",
				cancelText: "Cancel",
				onOk() {
					self.deleteChannel(channelId);
				},
				onCancel() {},
			});
		},
		async deleteChannel(channelId) {
			try {
				let deleteResponse = await this.channelMutations.deleteChannel(
					channelId
				);
				if (deleteResponse?.status == 200) {
					this.$message.success("Channel deleted successfully!");
				}
			} catch (error) {
				this.showError(error);
			} finally {
				this.$refs.channelsDataTable.refreshData(true);
			}
		},
		async showCustomLinkModal(channelId) {
      await this.fetchPlans();
			this.customPlanChannelId = channelId;
			this.isCustomLinkModalVisible = true;
		},
	},
	components: {
		ChannelModal,
		CustomPlanInvitation,
	},
};
</script>
